import * as angular from "angular";
import {IController} from "angular";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {TravelTimeRuleService} from "../../services/travel-time-rule-service.service";
import {TravelRuleType, TravelTimeRuleModel} from "../../models/travel-time-rule.model";
import {TravelTimeRuleDialogsService} from "../../services/travel-time-rule-dialogs.service";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";

const DEFAULT_GLOBAL_FACTOR = 100;

export class TravelTimeViewComponent implements IController {

  vehicleType?: VehicleType;

  public queryString: string;
  public vehicleTypes: VehicleType[];
  private _rules: TravelTimeRuleModel[];
  public rulesToShow: TravelTimeRuleModel[] = [];
  public globalRule?: TravelTimeRuleModel;
  public currentGlobalTravelTimeFactor: number = -1;
  public newGlobalTravelTimeFactor: number = DEFAULT_GLOBAL_FACTOR;

  public selectedRule?: TravelTimeRuleModel;
  public travelRuleType = TravelRuleType;
  public serviceAreas: any[];

  private serviceAreaRef: any;

  constructor(private travelTimeRuleService: TravelTimeRuleService,
              private travelTimeRuleDialogsService: TravelTimeRuleDialogsService,
              private confirmDialogService: ConfirmDialogService, private bringozToastService: BringozToastService,
              private $serviceArea, private $log, private serviceAreasService: ServiceAreasService) {
    this.vehicleTypes = Object.values(VehicleType);
    this.serviceAreaRef = this.$serviceArea();
  }

  $onInit() {
    if (!this.vehicleType) {
      this.vehicleType = this.vehicleTypes[0];
    }
    this._getRules();
    this._getAreas();
  }

  onTabChanged(vehicleType: VehicleType) {
    this.vehicleType = vehicleType;
    this._getRules();
  }

  onAddRule() {
    this.selectedRule = {
      name: undefined,
      type: TravelRuleType.AREA,
      referenceIds: [this.vehicleType],
      travelTimeFactor: 1,
      polygons: []
    }
  }

  onEditRule(rule) {
    this.selectedRule = rule;
  }

  onClosePanel() {
    this.selectedRule = undefined;
  }

  onCreateRule(rule: TravelTimeRuleModel) {
    this._createRule(rule);
  }

  onUpdateRule(rule: TravelTimeRuleModel) {
    this._updateRule(rule);
  }

  onDeleteRule(rule: TravelTimeRuleModel, $event) {
    const title = 'Delete Region';
    const body = 'Are you sure you want to delete this region?';

    this.confirmDialogService.confirm(title, body, $event)
      .then(() => {
        this._deleteRule(rule.id);
      })
      .catch(() => { })
  }

  private _getRules() {
    this.travelTimeRuleService.getRules(this.vehicleType)
      .then((rules: TravelTimeRuleModel[]) => {
        this._rules = rules;
        this.rulesToShow = this._rules.filter(rule => rule.type !== TravelRuleType.GLOBAL);
        this._updateHasGlobalRule();
      })
  }

  private _createRule(rule: TravelTimeRuleModel, updateGlobalRule = false) {
    const existingGlobalRule = this._rules.find(r => r.type === TravelRuleType.GLOBAL);
    if(updateGlobalRule && existingGlobalRule && existingGlobalRule.id === rule.id) {
      this.bringozToastService.error({body: "CANNOT_ADD_MORE_THAN_ONE_GLOBAL_TRAVEL_RULE"})
      return;
    }

    this.travelTimeRuleService.createRule(rule)
      .then((createdRule: TravelTimeRuleModel) => {
        this._rules = [createdRule].concat(this._rules);
        if (updateGlobalRule) {
          this._updateHasGlobalRule();
        }
        this.rulesToShow = this._rules.filter(rule => rule.type !== TravelRuleType.GLOBAL);
        this.onClosePanel();
      })
  }

  private _updateRule(rule: TravelTimeRuleModel, updateGlobalRule = false) {
    this.travelTimeRuleService.updateRule(rule.id, rule)
      .then((updatedRule: TravelTimeRuleModel) => {
        const rulesCopy = angular.copy(this._rules);
        const index = _.findIndex<any>(rulesCopy, (r) => {
          return r.id === rule.id
        });

        rulesCopy.splice(index, 1, updatedRule);
        this._rules = rulesCopy;

        if (updateGlobalRule) {
          this._updateHasGlobalRule();
        }
        this.rulesToShow = this._rules.filter(rule => rule.type !== TravelRuleType.GLOBAL);
        this.onClosePanel();
      })
  }

  private _updateHasGlobalRule() {
    this.globalRule = this._rules?.find(rule => rule.type === TravelRuleType.GLOBAL);

    if (this.globalRule) {
      this.currentGlobalTravelTimeFactor =  _.round(this.globalRule.travelTimeFactor * 100, 2);
      this.newGlobalTravelTimeFactor = this.currentGlobalTravelTimeFactor;
      return;
    }

    this.currentGlobalTravelTimeFactor = -1;
    this.newGlobalTravelTimeFactor = DEFAULT_GLOBAL_FACTOR;
  }

  onSaveGlobalRule() {
    const travelTimeFactor = _.round(this.newGlobalTravelTimeFactor / 100, 2);

    if (this.globalRule) {
      const ruleToUpdate = angular.copy(this.globalRule);

      ruleToUpdate.travelTimeFactor = travelTimeFactor;
      this._updateRule(ruleToUpdate, true);
    } else {
      const newGlobalRule: TravelTimeRuleModel = {
        name: 'Global',
        type: TravelRuleType.GLOBAL,
        referenceIds: [this.vehicleType],
        travelTimeFactor: travelTimeFactor,
        polygons: []
      };

      this._createRule(newGlobalRule, true);
    }
  }

  private _deleteRule(id: string) {
    this.travelTimeRuleService.deleteRule(id)
      .then((createdRule: TravelTimeRuleModel) => {
        this._rules = this._rules.filter((r) => {
          return r.id !== id;
        });
        this._updateHasGlobalRule();
      })
  }

  private _getAreas() {
    const payload = {
      branchIds: undefined,
      serviceTypes: undefined
    }

    this.serviceAreas = [];
    this.serviceAreasService.getAll(payload)
      .then((serviceAreas: any[]) => {
        this.serviceAreas = serviceAreas;
      });
    // this.serviceAreaRef.$getAll(payload)
    //   .then((ids) => {
    //     return this.serviceAreaRef.$asyncValues(ids);
    //   })
    //   .then((serviceAreas) => {
    //     this.serviceAreas = serviceAreas;
    //   })
    //   .catch((error) => {
    //     this.$log.error('Fail to $getAll', error);
    //   })
  }


}

angular
  .module('bringoz.admin.sites')
  .component('travelTimeView', {
    bindings: {
      vehicleType: '<?'
    },
    template: require('./travel-time-view.html').default,
    controller: TravelTimeViewComponent
  });
